module.exports = __webpack_public_path__ + "img/bookclubbannerbiggerbiggerbigger.280e438d.png";